import { IState } from '../../store';

export const selectLastDemandRequest = (state: IState) => state.requestDemand.lastDemandRequest;
